import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// NOTE: no StrictMode in dev. The double-mount it does races our acquire/release
// callables; revisit once lock acquisition is fully serialized.
createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
